import { AddButton as UIAddButton, type AddButtonProps } from '@jagad/ui'
import { useTranslation } from 'react-i18next'

const AddButton = (props: Omit<AddButtonProps, 'defaultLabel'>) => {
    const { t } = useTranslation()
    const defaultLabel = t('components.addButton.defaultLabel')
    return <UIAddButton {...props} defaultLabel={defaultLabel} />
}

export { AddButton as default }
